var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoFlash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#107DEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0574 8.44379C30.0574 8.89482 30.0574 9.34584 30.0574 9.79687C30.0574 14.7436 30.0719 19.6903 30.0429 24.637C30.0429 25.2481 30.2164 25.3936 30.8092 25.3936C34.5391 25.3645 38.269 25.379 41.9989 25.379C42.5194 25.379 42.7796 25.3936 42.4616 26.0192C38.3847 34.1376 34.3367 42.2706 30.2887 50.3891C30.2164 50.5346 30.1297 50.6655 29.9273 51.0001C29.9273 50.5346 29.9273 50.2872 29.9273 50.0253C29.9273 44.8895 29.9128 39.7391 29.9417 34.6032C29.9417 33.8321 29.7249 33.7012 29.0165 33.7157C25.3299 33.7448 21.6578 33.7157 17.9713 33.7448C17.3785 33.7448 17.2629 33.643 17.552 33.0756C21.6145 24.9717 25.648 16.8678 29.696 8.76388C29.7538 8.63293 29.8405 8.51654 29.9128 8.40015C29.9562 8.4147 29.9996 8.42924 30.0574 8.44379Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFlash);
export default __webpack_public_path__ + "static/media/logo_flash.9e06eb1b4da125c0a222630dce808279.svg";
export { ForwardRef as ReactComponent };